import useTranslation from "utils/hooks/useTranslation";
import { Popup } from "./Popup";

interface NeedHelpProps {
    closePopup: () => void;
    yesClick: () => void;
    noClick: () => void;
}

const SatisfactionPopup: React.FC<NeedHelpProps> = ({ 
    //closePopup, 
    yesClick, noClick }) => {
    const { t } = useTranslation();

    return <>
        <Popup
            title={t("THANKS_USING")}
            translateTitle
            fixSize={"middle"}

        >
            <>

                <group data-height="autofit" data-scroll="" data-space="20">
                    <group data-gap="20" data-height="fit">
                        <text data-wrap="wrap" data-text-size="large">{t("SURVEY_REQUEST")}</text>
                        <text data-wrap="wrap">{t("SURVEY_DESC")}</text>
                    </group>
                </group>

                <group data-space="20" data-gap="10">
                    <group data-length="forcefit" data-fit="1">
                        <div data-length="forcefit" className="button large secondary fit" effect="material" onClick={yesClick}>
                            {/* <icon data-icon-size="30">inventory_2</icon> */}
                            <text>{t("YES")}</text>
                        </div>
                    </group>
                    <group data-length="forcefit"  data-fit="1">
                        <div data-length="forcefit" className="button large secondary fit" effect="material" onClick={noClick}>
                            {/* <icon data-icon-size="30">inventory_2</icon> */}
                            <text>{t("NO")}</text>
                        </div>
                    </group>





                </group>
            </>
        </Popup>
    </>
}

export default SatisfactionPopup;